var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3985 36.3533C20.9551 36.3533 20.5118 36.19 20.1618 35.84C19.4851 35.1633 19.4851 34.0433 20.1618 33.3666L33.3685 20.16C34.0451 19.4833 35.1651 19.4833 35.8418 20.16C36.5185 20.8366 36.5185 21.9566 35.8418 22.6333L22.6351 35.84C22.3085 36.19 21.8418 36.3533 21.3985 36.3533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6051 36.3533C34.1618 36.3533 33.7185 36.19 33.3685 35.84L20.1618 22.6333C19.4851 21.9566 19.4851 20.8366 20.1618 20.16C20.8385 19.4833 21.9585 19.4833 22.6351 20.16L35.8418 33.3666C36.5185 34.0433 36.5185 35.1633 35.8418 35.84C35.4918 36.19 35.0485 36.3533 34.6051 36.3533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.56104a1ae3deb6d9b85cdcbbda13f998.svg";
export { ForwardRef as ReactComponent };